import React from 'react';
import {
  Box,
  Divider,
  Fade,
  FormControlLabel,
  InputAdornment,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { inputStyle } from '../constants';

const switchSx = {
  '& .Mui-checked': { color: '#05CD99 !important' },
  '& .Mui-checked + .MuiSwitch-track': { backgroundColor: '#05CD99 !important' },
};

const StepTarification = ({ formData, setFormData }) => {
  return (
    <Fade in>
      <Stack spacing={3}>
        {/* Champ Prix de la prestation */}
        <TextField
          fullWidth
          type="number"
          label="Prix de la prestation"
          InputProps={{
            endAdornment: <InputAdornment position="end">€</InputAdornment>,
          }}
          value={formData.prix_offre}
          onChange={(e) => {
            const value = e.target.value;
            // Si tu veux que prix_client prenne automatiquement la même valeur que prix_offre :
            setFormData({ 
              ...formData, 
              prix_offre: value,
              prix_client: value // Synchronisation automatique du prix client
            });
          }}
          sx={inputStyle}
        />

        {/* Champ Prix Spécial SOA */}
        <TextField
          fullWidth
          type="number"
          label="Prix Spécial SOA"
          InputProps={{
            endAdornment: <InputAdornment position="end">€</InputAdornment>,
          }}
          value={formData.prix_special_soa}
          onChange={(e) => setFormData({ ...formData, prix_special_soa: e.target.value })}
          sx={inputStyle}
        />

        <Box sx={{ p: 4, bgcolor: '#F9FBFF', borderRadius: '24px', border: '1px solid #E2EBF6' }}>
          <Typography variant="subtitle1" fontWeight="800" color="#1B2559" mb={3}>
            Configuration & Droits d'accès
          </Typography>

          <Stack spacing={2.5}>
            {/* 1. STATUS DE L'OFFRE */}
            <FormControlLabel
              control={
                <Switch
                  sx={switchSx}
                  checked={formData.status}
                  onChange={(e) => setFormData({ ...formData, status: e.target.checked })}
                />
              }
              label={
                <Box sx={{ ml: 1 }}>
                  <Typography fontWeight="700" color="#1B2559">
                    {formData.status ? 'Offre Activée' : 'Offre Désactivée'}
                  </Typography>
                  <Typography variant="caption" color="#A3AED0">
                    Rendre cette prestation visible et réservable.
                  </Typography>
                </Box>
              }
            />

            <Divider sx={{ borderStyle: 'dashed' }} />

            {/* 2. PRIVILÈGE ABONNÉ */}
            <FormControlLabel
              control={
                <Switch
                  sx={switchSx}
                  checked={formData.is_accessible_participant}
                  onChange={(e) =>
                    setFormData({ ...formData, is_accessible_participant: e.target.checked })
                  }
                />
              }
              label={
                <Box sx={{ ml: 1 }}>
                  <Typography fontWeight="700" color="#1B2559">
                    {formData.is_accessible_participant
                      ? "Inclus dans l'abonnement"
                      : 'Hors abonnement'}
                  </Typography>
                  <Typography variant="caption" color="#A3AED0">
                    {formData.is_accessible_participant
                      ? 'Les abonnés accèdent à cette offre gratuitement.'
                      : 'Tout le monde doit payer pour cette prestation.'}
                  </Typography>
                </Box>
              }
            />

            <Divider sx={{ borderStyle: 'dashed' }} />

            {/* 3. PAIEMENT À LA RÉSERVATION */}
            <FormControlLabel
              control={
                <Switch
                  sx={switchSx}
                  checked={formData.is_paid_offre}
                  onChange={(e) => setFormData({ ...formData, is_paid_offre: e.target.checked })}
                />
              }
              label={
                <Box sx={{ ml: 1 }}>
                  <Typography fontWeight="700" color="#1B2559">
                    Paiement à la réservation
                  </Typography>
                  <Typography variant="caption" color="#A3AED0">
                    Exiger le règlement immédiat lors de la réservation.
                  </Typography>
                </Box>
              }
            />
          </Stack>
        </Box>
      </Stack>
    </Fade>
  );
};

export default StepTarification;